import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "page-wrap" }
const _hoisted_2 = { class: "page-bar" }
const _hoisted_3 = { class: "page-bar-main" }
const _hoisted_4 = {
  style: {"display":"flex","align-items":"center"},
  class: "hide-mobile-991"
}
const _hoisted_5 = {
  key: 0,
  class: "page-filters pf-bar"
}
const _hoisted_6 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_7 = {
  class: "playbook",
  style: {"padding":"20px 20px 0"}
}
const _hoisted_8 = {
  class: "next-nodes",
  style: {"display":"flex","flex-direction":"column","align-items":"center"}
}
const _hoisted_9 = { class: "next-node-btn-wrap" }
const _hoisted_10 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_add_edit_onboarding = _resolveComponent("add-edit-onboarding")!
  const _component_onboarding_pop_up = _resolveComponent("onboarding-pop-up")!
  const _component_onboarding_signatures = _resolveComponent("onboarding-signatures")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", null, [
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "page-bar-sub" }, "Team", -1)),
        _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.onboarding.Name), 1)
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", {
          class: "btn-light",
          style: {"margin-right":"15px"},
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$router.back()))
        }, "Back")
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(_ctx.$store.state.routeLoaded ? 'slide-up view' : 'hide')
    }, [
      (_ctx.$store.state.user.teamHubRole == 'Admin')
        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
            _createElementVNode("div", {
              onClick: _cache[1] || (_cache[1] = () => { _ctx.showSigs = true }),
              class: "add-btn"
            }, "Signatures"),
            _createElementVNode("div", {
              onClick: _cache[2] || (_cache[2] = () => { _ctx.showEdit = true }),
              class: "add-btn"
            }, "Edit")
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", _hoisted_8, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.onboarding.StepsJSON, (step, i) => {
              return (_openBlock(), _createElementBlock("div", { key: i }, [
                _createElementVNode("div", _hoisted_9, [
                  _createElementVNode("div", {
                    class: "btn",
                    onClick: ($event: any) => (_ctx.showStepFn(step, i)),
                    style: _normalizeStyle(_ctx.userSignOffs[step.id] ? 'background:green;border-color:green' : '')
                  }, _toDisplayString(step.name), 13, _hoisted_10)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ], 2),
    (_ctx.showEdit)
      ? (_openBlock(), _createBlock(_component_add_edit_onboarding, {
          key: 0,
          onboardingToEdit: _ctx.onboarding,
          onClose: _cache[3] || (_cache[3] = () => { _ctx.getOnboarding(); _ctx.showEdit = false })
        }, null, 8, ["onboardingToEdit"]))
      : _createCommentVNode("", true),
    (_ctx.showStep)
      ? (_openBlock(), _createBlock(_component_onboarding_pop_up, {
          key: 1,
          step: _ctx.stepToShow,
          userSignOffs: _ctx.userSignOffs,
          onClose: _cache[4] || (_cache[4] = () => { _ctx.showStep = false; }),
          onSaveSignOffs: _ctx.saveSignOffs
        }, null, 8, ["step", "userSignOffs", "onSaveSignOffs"]))
      : _createCommentVNode("", true),
    (_ctx.showSigs)
      ? (_openBlock(), _createBlock(_component_onboarding_signatures, {
          key: 2,
          onClose: _cache[5] || (_cache[5] = () => { _ctx.showSigs = false }),
          onboardingProp: _ctx.onboarding
        }, null, 8, ["onboardingProp"]))
      : _createCommentVNode("", true)
  ]))
}